// src/config/plans.ts
import { Zap, Building, ShieldCheck } from "lucide-react";

export const PLANS = [
  {
    id: "freelance",
    name: "Freelance",
    price: "199,90",
    tokens: "2.000 Tokens (aprox. 20 análises)",
    icon: Zap,
    description: "Ideal para consultores individuais buscando agilidade.",
    features: ["Acesso ao Dashboard", "Análise de Editais Básica", "Histórico de 30 dias", "Suporte por Email"],
    popular: false
  },
  {
    id: "business",
    name: "Business",
    price: "599,90",
    tokens: "5.000 Tokens (aprox. 50 análises)",
    icon: Building,
    description: "Para empresas que precisam de volume e múltiplos usuários.",
    features: ["Tudo do Freelance", "Acesso à API", "Múltiplos Usuários", "Análises Prioritárias"],
    popular: true
  },
  {
    id: "enterprise",
    name: "Enterprise",
    price: "1599,90",
    tokens: "Tokens Ilimitados",
    icon: ShieldCheck,
    description: "Poder total para grandes operações e consórcios.",
    features: ["Treinamento de IA Customizado", "SSO & Segurança Avançada", "Gerente de Conta", "Suporte 24/7"],
    popular: false
  }
];